import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor() { }

  validURL(str) {
    var pattern = new RegExp('^((ft|htt)ps?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?'+ // port
    '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?'+ // query string
    '(\\#[-a-z\\d%@_.,~+&:=-]*)?$','i'); // fragment locator
    return pattern.test(str);
  }


  processContent(str, taggedMembers = []) {

    // Find all urls in str
    let urls = str.match(/((ft|htt)ps?:\/\/)?((([a-zA-Z\d]([a-zA-Z\d-]*[a-zA-Z\d])*)\.)+[a-zA-Z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-zA-Z\d%@_.~+&:]*)*(\?[;&a-zA-Z\d%@_.,~+&:=-]*)?(\#[-a-zA-Z\d%@_.,~+&:=-]*)?/g) || [];
    let mailtos = str.match(/(mailto|tel):([^\s'"]+)/g) || [];
    let urlIndeces = [];

    if ((!!urls && urls.length) || (!!mailtos && mailtos.length)) {

      // Set urlIndeces
      [...urls, ...mailtos].forEach(u => {
        let indeces = this.getIndicesOf(u, str)
        indeces.forEach(i => {
          if (urlIndeces.length) {
            if(urlIndeces.every(ind => ind.index !== i)) urlIndeces.push({index: i, url: u})
          } else {
            urlIndeces.push({index: i, url: u})
          }
        })
      })

      // filter out any 'urls' that fall within another url
      let filteredInd = urlIndeces.filter(uFilter => {
        let bounds = [uFilter.index, (uFilter.index + uFilter.url.length)] 
        return urlIndeces.map(uMap => {
            let boundsSome = [uMap.index, (uMap.index + uMap.url.length)]
            return  (bounds[0] !== boundsSome[0] && bounds[1] !== boundsSome[1]) && // dont filter out the same url
                    (bounds[0] >= boundsSome[0] && bounds[1] <= boundsSome[1]) ? // filter out any "urls" that fall within another url
                    false : true;
        }).every(m => m)
      })

      // check if url is already wrapped in anchor tag, otherwise wrap it
      for (let i = filteredInd.length - 1; i > -1; i--) {
        let url = filteredInd[i];
        if (
          !(str.substring(url.index - 6).startsWith('href') || // exclude if preceded by href
          str.substring(url.index - 7).startsWith('mailto:') || // or the start of an email address
          str.substring(url.index - 1).startsWith('@') || // or the end of an email address
          str.substring(url.index + url.url.length).startsWith('</a>')) // or followed by a closing anchor tag
          ) {
            let anchor = `<a href="${url.url.includes('http') ? url.url : 'http://' + url.url}" target="_blank">${url.url}</a>`;
            str = str.substring(0, url.index) + anchor + str.substring(url.index + url.url.length);
        }
      }
    }

    // check for tagged members
    if (taggedMembers.length) {
      for (const member of taggedMembers) {
        const handle = `@${member.displayName}`
        if (str.includes(handle)) {
          str = str.replaceAll(handle, `<a href="/member/${member.uid}" class="member-handle">${handle}</a>`)
          // str = str.replace(handle, `<ngx-dynamic-hooks [content]="content <oc-handle [id]='${member.uid}' [handle]='${handle}'></oc-handle>">Hook Inner</ngx-dynamic-hooks>`)
        }
      }
    }

    return str.substring(
      // remove whitespace and empty tags at beginning of string
      str.match(/^(((<p><\/p>)|(<p><br><\/p>))(\n|\r)*)*/g)[0].length
    )
  }

  getIndicesOf(searchStr, str) {
    var searchStrLen = searchStr.length;
    if (searchStrLen == 0) {
        return [];
    }
    var startIndex = 0, index, indices = [];
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
  }
}



